module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/16mill-active-92a280fe4ae287e05dfb4d6c2be0a1ee.png";